/**
 * Created by JackCui on 2020/10/21
 */
 import batchHandleUrl from '../../../utils/url-handle'

 const Api = {
   // template
   queryTemplate: {
     url: '/apaas/excel/queryTemplate',
     type: 'post'
   },
   // 导出
   export: {
     url: '/apaas/excel/export',
     type: 'post'
   },
   // 导入
   import: {
     url: '/apaas/excel/import',
     type: 'post'
   }
 }
 
 export default batchHandleUrl(Api)
 